<template>
	<div id="content_body">
		<header-layout :pageHeaderStyle="pageHeaderStyle" :pageHeaderBg="pageHeaderBg" :pageHeaderSpacing="pageHeaderSpacing" :pageHeaderContainer="pageHeaderContainer" :pageTitle="pageTitle" :pageSubtitle="pageSubtitle" :pageIcon="pageIcon"></header-layout>
		<div class="container mt-n15">
			<!-- invoice -->
			<div class="card">
				<div class="card-header">
					<b-form ref="instanceForm" id="instanceForm" autocomplete="off" >
						<!-- Flash -->
						<div v-if="$store.getters.flash.msg" class="alert alert-danger" role="alert" v-html="$store.getters.flash.msg" />

						<!-- 1- SIMPLE v-if="typeAdd === 'one' || typeAdd === 'vcc'"-->
						<div class="form-row">
							<div class="col-md-3">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.mvtTypeMvt')}}
									</label>
									<select v-model="mvtTypeMvtSelected" class="form-control" :class="{'is-invalid': v$.instance.mvtTypeMvt.$error, 'is-valid': (!v$.instance.mvtTypeMvt.$error && v$.instance.mvtTypeMvt.$dirty) }" :disabled="typeView != 'new'">
										<option v-for="mvtTypeMvt in mvtTypeMvtList" :value="mvtTypeMvt.id" :key="mvtTypeMvt.id">
										{{ mvtTypeMvt.typeMvtName}}
										</option>
									</select>
									<span class="small text-muted d-md-block" v-if="v$.instance.mvtTypeMvt.$error">
										{{ v$.instance.mvtTypeMvt.$errors[0].$message }}
									</span>										
								</div>
							</div>
							<div class="col-md-6">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.mvtAccount')}}
									</label>
									<select v-model="mvtAccountSelected" class="form-control" :class="{'is-invalid': v$.instance.mvtAccount.$error, 'is-valid': (!v$.instance.mvtAccount.$error 
									&& v$.instance.mvtAccount.$dirty) }" :disabled="typeView != 'new'">
										<option v-for="mvtAccount in mvtAccountList" :value="mvtAccount.id" :key="mvtAccount.id">
										{{ mvtAccount.lib}} | Solde: {{$store.getters.formatAmount(mvtAccount.solde)}}
										</option>
									</select>
									<span class="small text-muted d-md-block" v-if="v$.instance.mvtAccount.$error">
										{{ v$.instance.mvtAccount.$errors[0].$message }}
									</span>							
								</div>
							</div>
							<div class="col-md-3">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.mvtTypeDep')}}
								</label>
								<select v-model="mvtTypeDepSelected" class="form-control" :class="{'is-invalid': v$.instance.mvtTypeDep.$error, 'is-valid': (!v$.instance.mvtTypeDep.$error && v$.instance.mvtTypeDep.$dirty) }" :disabled="typeView=='show'">
									<option v-for="mvtTypeDep in mvtTypeDepList" :value="mvtTypeDep.id" :key="mvtTypeDep.id">
										{{mvtTypeDep.typeDepName}}
									</option>
								</select>	
								<span class="small text-muted d-md-block" v-if="v$.instance.mvtTypeDep.$error">
									{{ v$.instance.mvtTypeDep.$errors[0].$message }}
								</span>
							</div>
							<div class="col-md-12" v-show="[6,7].includes(mvtTypeDepSelected) && (typeAdd === 'one' || (itemId && !isNaN(itemId) ) )">
								<div class="form-group">
									<label>
										{{ $t(instanceClassAttr.instanceClass+'.mvtAccountInv')}}
									</label>
									<!-- :class="{'is-invalid': v$.instance.mvtAccountInv.$error, 'is-valid': (!v$.instance.mvtAccountInv.$error && v$.instance.mvtAccountInv.$dirty) }" v-if="([6,7].includes(typeDep) || [6,7].includes(mvtTypeDepSelected)) && typeAdd === 'one'"-->
									<select v-model="mvtAccountInvSelected" class="form-control" :disabled="typeView != 'new'">
										<option v-for="mvtAccountInv in mvtAccountInvList" :value="mvtAccountInv.id" :key="mvtAccountInv.id">
										{{ mvtAccountInv.lib}} | Solde: {{$store.getters.formatAmount(mvtAccountInv.solde)}}
										</option>
									</select>
									<span class="small text-muted d-md-block" v-if="v$.instance.mvtAccountInv && v$.instance.mvtAccountInv.$error">
										{{ v$.instance.mvtAccountInv.$errors[0].$message }}
									</span>							
								</div>
							</div>
							
							<div class="col-md-3" v-if="typeAdd === 'one'">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.mvtAmount')}}
								</label>
								<input type="number" step="any" v-model="instance.mvtAmount" class="form-control" :disabled="typeView=='show'" :class="{'is-invalid': v$.instance.mvtAmount.$error, 'is-valid': (!v$.instance.mvtAmount.$error && v$.instance.mvtAmount.$dirty) }" @input="amountToLetter($event, 'amount')" @change="amountLetter = {}"/>
								<span class="small text-muted d-md-block" v-if="v$.instance.mvtAmount.$error">
									{{ v$.instance.mvtAmount.$errors[0].$message }}
								</span>
								<span v-if="amountLetter && amountLetter.amount != '' " class="amount-letter">
									{{amountLetter.amount}}
								</span>
							</div>
							<div class="col-md-6" v-if="typeAdd === 'one'">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.justificatif')}}
								</label>
								<input type="text" v-model="instance.justificatif" class="form-control" :class="{'is-invalid': v$.instance.justificatif.$error, 'is-valid': (!v$.instance.justificatif.$error && v$.instance.justificatif.$dirty) }" :disabled="typeView=='show'"/>
								<span class="small text-muted d-none d-md-block" v-if="v$.instance.justificatif.$error">
									{{ v$.instance.justificatif.$errors[0].$message }}
								</span>
							</div>
							
							<div class="col-md-3" v-if="typeAdd === 'one'">
								<label>
									{{ $t(instanceClassAttr.instanceClass+'.mvtDate')}}
								</label>
								<input type="date" v-model="instance.mvtDate" class="form-control" :class="{'is-invalid': v$.instance.mvtDate.$error, 'is-valid': (!v$.instance.mvtDate.$error && v$.instance.mvtDate.$dirty) }" :disabled="typeView=='show'"/>
								<span class="small text-muted d-md-block" v-if="v$.instance.mvtDate.$error">
									{{ v$.instance.mvtDate.$errors[0].$message }}
								</span>
							</div>
						</div>
					</b-form>
				</div>
				<div v-if="typesMany.includes(typeAdd)" class="card-body">
					<!-- 2- MULTIPLE -->
					<div v-if="typesMany.includes(typeAdd)" class="table-responsive">
						<span class="small text-muted d-md-block" v-if="v$.mvtMovementList.$error">
							{{ v$.mvtMovementList.$errors[0].$message }}
						</span>
						<table id="instanceTable" class="table table-sm table-striped table-bordered table-hover mb-0">
							<thead class="border-bottom thead-light">
								<tr class="small text-uppercase text-muted">
									<th scope="col" width="3%">
										#
									</th>
									<th scope="col" width="37%">
										{{ $t(instanceClassAttr.instanceClass+'.mvtAccount')}}
									</th>
									<th scope="col" width="25%" class="align-right">
										{{ $t(instanceClassAttr.instanceClass+'.mvtAmount')}}
									</th>
									<!-- <th v-if="typeAdd === 'vcc'" scope="col" width="20%" class="align-left">
										{{ $t(instanceClassAttr.instanceClass+'.mvtDate')}}
									</th> -->
									<th v-if="typeAdd === 'vcc'" scope="col" width="27%" class="align-left">
										{{ $t(instanceClassAttr.instanceClass+'.justificatif')}}
									</th>
									<th scope="col" v-if="typeView != 'show'" width="8%" class="align-center">
										{{ $t('default.actions')}}
									</th>
								</tr>
							</thead>
							<tbody>
								<tr class="border-bottom" v-for="(mvt,index) in mvtMovementList" :key="mvt.id">
									<td>
										<div class="small text-muted">
											{{ (index+1) }}
										</div>
									</td>
									<td>
										<div class="font-weight-bold">
											<!-- {{mvt.mvtSoldeLib}} FCFA -->
											{{mvt.mvtAccountLib}} | Solde: {{$store.getters.formatAmount(mvt.mvtSolde )}}
										</div>
									</td>
									<td>
										<div class="input-group small text-muted">
											<input type="number" step="any" :max="mvt.mvtAmount" :min="0" v-model="mvt.mvtAmount" class="form-control" :disabled="typeView=='show'"	@input="amountToLetter($event, 'mvtAmount')" @change="amountLetter = {}"
											/>
										</div>
									</td>
									<!-- <td v-if="typeAdd === 'vcc'">
										<div class="input-group small text-muted">
											<input type="date" v-model="mvt.mvtDate" class="form-control"/>
										</div>
									</td> -->
									<td v-if="typeAdd === 'vcc'">
										<div class="input-group small text-muted">
											<input type="text" v-model="mvt.justificatif" class="form-control"/>
										</div>
									</td>
									<td v-if="typeView != 'show'" class="align-center">
										<div class=""> 
											<button class="btn btn-danger btn-icon btn-xs" @click="removeRow(mvt, index)">
												<fa icon="minus"/>
											</button>
										</div>
									</td>
								</tr>
								<tr v-if="typesMany.includes(typeAdd) && typeView != 'show'" class="border-bottom table-default">
									<td v-show="amountLetter && amountLetter.mvtAmount != ''" align="center" colspan="6" >
										<span v-if="amountLetter && amountLetter.mvtAmount != '' " class="amount-letter">
											{{amountLetter.mvtAmount}}
										</span>
									</td>
								</tr>
								<tr v-if="typesMany.includes(typeAdd) && typeView != 'show'" class="border-bottom table-warning">
									<td v-show="activeAddRow" align="center" colspan="6" >
										<auto-search :paramsSearch="paramsSearchEmp" @updateOnClick="addRow" :key="autoSearchKey"/>
									</td>
									<td v-show="!activeAddRow" align="center" colspan="6"
									>
										<b-button class="btn btn-sm btn-success" 
											@click="activeAddRow=true; autoSearchKey++;" >
											<span>
												<fa class="fa-lg" icon="plus-circle"/>
											</span>
										</b-button>
									</td>
								</tr>

							</tbody>
						</table>
					</div>
				</div>
				

				<div class="card-footer" v-if="$store.getters.isAuthorized(['ROLE_MANAGER', 'ROLE_VENTE'])">
					<div class="row">
						<div class="col-md-4" align="left">
							<b-button v-if="typeView != 'show'" class="btn btn-success" 
								@click="handleSubmit()" >
								<span v-if="typeView == 'new'">
									<fa icon="check"/>
									{{ $t("default.button.create")}}
								</span>
								<span v-if="typeView == 'edit'">
									<fa icon="check"/>
									{{ $t("default.button.update")}}
								</span>
							</b-button>
							&ensp;
							<b-button v-if="typeView == 'edit'" class="btn btn-dark" @click="typeView = 'show'" >
								<span>
									<fa icon="times"/>
									{{ $t("default.button.cancel")}}
								</span>
							</b-button>
							
							<b-button v-if="typeView == 'show'
							&& $store.getters.isAuthorized(['ROLE_MANAGER'])" class="btn btn-primary" 
								@click="typeView = 'edit'" >
								<span>
									<fa icon="edit"/>
									{{ $t("default.button.edit")}}
								</span>
							</b-button>
						</div>
						<div class="col-md-4" align="center"></div>
						<div v-if="typeView == 'show'" class="col-md-4" align="right">
							<b-button id="print"
								variant="primary" class="btn btn-info" type="button" @click="produce()">
								<fa icon="print"/>
								&nbsp;
								{{this.$t('mvtmovement.button.print')}}
							</b-button>
							<modal-pdf-viewer 
								ref="componentModalPdf" 
								:pdfSrc="pdfSrc"
								:pdfName="pdfName"
							/>
						</div>
					</div>
				</div>
				
			</div>
		</div>
	</div>

</template>
<script>
	import Header from '@/layouts/templates/Header.vue';
	import AutoSearch from '@/components/templates/AutoSearch.vue';
	import ModalPdfViewer from '@/components/templates/Modals/ModalPdfViewer.vue'	
	
	import { useVuelidate } from '@vuelidate/core'
	import { required, email,minLength, maxLength } from '@vuelidate/validators'

	export default {
		name: 'mvtMovement',
		props: {
			typeMvt: {
				type: Number,
				default: NaN,
				required: false
			},
			typeDep: {
				type: Number,
				default: NaN,
				required: false
			},
			accId: {
				type: Number,
				default: NaN,
				required: false
			},
			itemId: {
				type: Number,
				default: NaN,
				required: false
			},
			typeAdd: {
				type: String,
				default: 'one',
				required: false
			}
		},
		
		setup () { return { v$: useVuelidate() }},
		components: {
			'header-layout': Header,
			'auto-search': AutoSearch,
			'modal-pdf-viewer': ModalPdfViewer
		},
		
		data() {
			return {
				pageHeaderStyle: process.env.VUE_APP_PAGE_HEADER_STYLE,
				pageHeaderBg: process.env.VUE_APP_PAGE_HEADER_BG,
				pageHeaderSpacing: 'pb-10',
				pageHeaderContainer: 'container',
				pageSubtitle: this.$t('mvtmovement.label'),
				pageTitle: this.$t('mvtmovement.show'),
				pageIcon: 'hourglass-half',
				instanceClassAttr: {
					instanceClass: 'mvtmovement'
				},

				instance: {
					mvtTypeMvt:'',
					mvtTypeDep: '',
					justificatif: '',
					mvtAmount: '',
					mvtAccount: '',
					mvtDate: new Date().toISOString().split('T')[0],
				},
				paramsSearchEmp: {
					placeholder: 'Search Emp',
					attrView: 'mvtAccountLib',
					filterList: [],
					listOpen: true,
					btnReturn: true,
					icon: 'user',
				},
				typeMany: 'remb',
				typesMany: ['remb', 'vcc'],
				mvtMovementList: [],
				activeAddRow: false,
				rowsAdded: {},
				invKey: 0,
				autoSearchKey: 0,
				vueRules: {},
				mvtTypeMvtSelected: '',
				mvtAccountSelected: '',
				mvtAccountInvSelected: '',
				mvtTypeDepSelected: '',
				
				mvtTypeMvtList: [],
				mvtAccountList: [],
				mvtAccountInvList: [],
				mvtTypeDepList:[],
				amountLetter: {},
				typeView: 'new', // new, show, edit
				pdfSrc:'',
				pdfName:'Fiche de mouvement',
				
			}
		},
		validations () {
			return this.vueRules
		},
		async created (){
			this.vueRules = this.createVeerules()
		},
		async mounted () {
			this.$store.dispatch('initFlash');
			if(this.$store.getters.loggedIn) {
				// GET LIST mvttypemvt
				await this.$store.dispatch('axiosGet', {
					domain: 'mvttypemvt'
				})
				.then(response => {
					this.mvtTypeMvtList = response.data
				})
				.catch(error => {
					console.log('error catch mvttypemvt == ', error.message)
				})
				// GET LIST mvttypedep
				await this.$store.dispatch('axiosGet', {
					domain: 'mvttypedep'
				})
				.then(response => {
					this.mvtTypeDepList = response.data
				})
				.catch(error => {
					console.log('error catch mvttypedep == ', error.message)
				})
				
				// GET LIST mvtaccount
				let strParamsA = "typeRender=list"
				// strParamsA = strParamsA+"&aliasList=_prsPerson"
				// strParamsA = strParamsA+"&aliasList=_prsPerson"
				// Si show on get all fr pour affichage accountInv lors des achats
				// if(this.itemId && !isNaN(this.itemId) )
				// 	strParamsA = strParamsA+"&params1=_prsPerson.prsType.id&valParams1="+3+"&logParams1=eqL"
				// else
				// 	strParamsA = strParamsA+"&params1=prsPerson.id&valParams1="+1+"&logParams1=eqL"

				// strParamsA = strParamsA+"&params2=prsStore.id&valParams2="+null+"&logParams2=eqL"

				await this.$store.dispatch('axiosGet', { url: '/api/mvtaccount/getbycriteria?' + strParamsA
				})
				.then(response => {
					if(response.data){
						this.mvtAccountList = response.data
						if(isNaN(this.accId)){
							if(this.$store.getters.isAuthorized(['ROLE_VENTE'])){
								if(isNaN(this.itemId))
									this.mvtAccountList = this.mvtAccountList.filter(item => item.prsStore != null && item.prsPerson.id == 1 )
								else
									this.mvtAccountList = this.mvtAccountList.filter(item => item.prsPerson.prsStore?.id == this.$store.getters.prsInfo.prsStore)
							}
							// CAS DES PAIEMENTS FR
							else if((this.typeDep && !isNaN(this.typeDep) && this.typeDep == 7) || (this.mvtTypeDepSelected && this.mvtTypeDepSelected == 7) )
								this.mvtAccountList = this.mvtAccountList.filter(item => item.prsPerson != null && item.prsPerson.prsType.typeCode == 'FRA' && item.prsPerson.id > 1)
							else if(isNaN(this.itemId))
								this.mvtAccountList = this.mvtAccountList.filter(item => item.prsStore == null && item.prsPerson.id == 1 )
						}
					}
				})
				.catch(error => {
					console.log('error catch -mvtAccountInvList == ', error.message)
				})

				
				// GET LIST mvtaccountinv
				let strParams = "typeRender=list"
				strParams = strParams+"&aliasList=_prsPerson"
				// Si show on get all fr pour affichage accountInv lors des achats
				if(this.itemId && !isNaN(this.itemId) )
					strParams = strParams+"&params1=_prsPerson.prsType.id&valParams1="+[3,5]+"&logParams1=inL"
				else
					strParams = strParams+"&params1=prsPerson.id&valParams1="+1+"&logParams1=eqL"

				// strParams = strParams+"&params2=prsStore.id&valParams2="+null+"&logParams2=eqL"

				await this.$store.dispatch('axiosGet', { url: '/api/mvtaccount/getbycriteria?' + strParams
				})
				.then(response => {
					if(response.data){
						this.mvtAccountInvList = response.data;
						if(isNaN(this.itemId) )
							this.mvtAccountInvList = this.mvtAccountInvList.filter(item => item.prsStore == null)
					}
				})
				.catch(error => {
					console.log('error catch -mvtAccountInvList == ', error.message)
				})

				if(this.itemId && !isNaN(this.itemId)){
					await this.$store.dispatch('axiosGet', {
						domain: 'mvtmovement',
						id: this.itemId
					})
					.then(response => {
						this.typeView = 'show'
						this.pageTitle = this.$t('mvtmovement.'+this.typeView)
						if(response.data){
							this.instance = response.data
							this.instance.mvtDate = this.$moment(this.instance.mvtDate).format('YYYY-MM-DD').toString()

							this.mvtTypeMvtSelected = this.instance.mvtTypeMvt?this.instance.mvtTypeMvt.id : ''
							this.mvtTypeDepSelected = this.instance.mvtTypeDep ? Number(this.instance.mvtTypeDep.id) : ''
							this.mvtAccountSelected = this.instance.mvtAccount?this.instance.mvtAccount.id : ''
							if(this.instance.mvtAccountInv)
								this.mvtAccountInvSelected = this.instance.mvtAccountInv?this.instance.mvtAccountInv.id : ''
							this.amountToLetter({target:{value:this.instance.mvtAmount?.toString()}}, 'mvtAmount')
							this.amountToLetter({target:{value:this.instance.mvtSolde?.toString()}}, 'mvtSolde')
							
						}
					})
					.catch(error => {
						console.log('error catch mvtmovement == ', error.message)
					})
				}
				if(this.typeMvt && !isNaN(this.typeMvt)){
					this.mvtTypeMvtSelected = this.typeMvt
					// this.instance.mvtTypeMvt = [this.typeMvt]
					this.mvtTypeMvtList = this.mvtTypeMvtList.filter(item => item.id == this.typeMvt)
					this.instance.mvtTypeMvt = this.mvtTypeMvtList[0]
				}
				if(this.typeDep && !isNaN(this.typeDep)){
					this.mvtTypeDepSelected = Number(this.typeDep)//.toInteger()
					// this.instance.mvtTypeDep = [this.typeDep]
					this.mvtTypeDepList = this.mvtTypeDepList.filter(item => item.id == this.typeDep)
					this.instance.mvtTypeDep = this.mvtTypeDepList[0]
				}
				if(this.accId && !isNaN(this.accId)){
					this.mvtAccountSelected = this.accId
					// this.instance.mvtAccount = [this.accId]
					this.mvtAccountList = this.mvtAccountList.filter(item => item.id == this.accId)
					this.mvtAccountInvList = this.mvtAccountInvList.filter(item => item.id != this.accId)
					this.instance.mvtAccount = this.mvtAccountList[0] 
				}
				else if(!this.itemId && this.$store.getters.prsInfo.prsStore && this.$store.getters.isAuthorized(['ROLE_VENTE'])) {
					this.mvtAccountList = this.mvtAccountList.filter(item => item.prsStore?.id == this.$store.getters.prsInfo.prsStore)
					this.instance.mvtAccount = this.mvtAccountList[0]
					this.mvtAccountSelected = this.instance.mvtAccount?.id
				}
				// CAS de multiple.
				if(this.typeAdd && this.typesMany.includes(this.typeAdd)){
					this.pageTitle = this.$t('mvtmovement.'+this.typeView+''+this.typeAdd)
					// GET LIST mvtMovementList
					if(this.typeAdd == 'remb'){
						// url: '/api/mvtmovement/createremb?typeMany='+this.typeMany
						await this.$store.dispatch('axiosGet', {
							domain: 'mvtmovement/createremb'
						})
						.then(response => {
							if(response.data && response.data.mvtMovementList){
								this.paramsSearchEmp.filterList = response.data.mvtMovementList
								//this.paramsSearchEmp.filterList.push(...response.data.mvtMovementList)
							}
						})
						.catch(error => {
							console.log('error catch mvtMovementList == ', error.message)
						})
					}
					else if(this.typeAdd == 'vcc'){
						let strJustif = 'Ref: ... / ...'
						/*for(let i = 0; i < this.mvtAccountInvList.length; i++) {
							let accountInv = this.mvtAccountInvList [i];
							let row = {
								id: 'invKey_'+i,
								mvtAccountInv: accountInv?.id,
								mvtAccountLib: accountInv?.lib,
								mvtSolde: accountInv?.solde,
								mvtSoldeLib: accountInv?.solde,
								justificatif: strJustif
							}
							if(row.id != this.mvtAccountSelected)
								this.paramsSearchEmp.filterList.push(row)

						}*/
						this.mvtAccountInvList.forEach(accountInv =>{
							let row = {
								id: accountInv?.id,
								mvtAccountInv: accountInv?.id,
								mvtAccountLib: accountInv?.lib,
								mvtSolde: accountInv?.solde,
								mvtSoldeLib: accountInv?.solde,
								justificatif: strJustif
							}
							if(row.id != this.mvtAccountSelected)
								this.paramsSearchEmp.filterList.push(row)
						})

					}
				}


			}
			this.pageTitle = this.$t('mvtmovement.'+this.typeView)
		},
		methods: {
			createVeerules(){
				let rules = {
					instance: {
						mvtAccount: { required },
						// mvtAccountInv: { required },
						mvtTypeMvt: { required },
						mvtTypeDep: { required },
						justificatif: { required },
						mvtAmount: { required },
						mvtDate: { required }
					}
				}
				// this.typesMany.includes(this.typeAdd)
				if(this.typeAdd !== 'one'){
					rules = {
						mvtMovementList: { required },
						instance: {
							mvtAccount: { required },
							mvtTypeMvt: { required },
							mvtTypeDep: { required }
						}
					}
				}
				return rules
			},
			removeRow(row, i){
				if(this.typeAdd === 'remb'){
					this.mvtMovementList = this.mvtMovementList.filter(item => item.id !== row.id)
					this.paramsSearchEmp.filterList.push(this.rowsAdded[row.id])
				}
				else if(this.typeAdd === 'vcc')
					this.mvtMovementList = this.mvtMovementList.filter((_, index) => index !== i);
			},
			addRow(row){
				if(row){
					// on restraint la liste filter after click
					if(this.typeAdd === 'remb'){
						let newList = this.paramsSearchEmp.filterList.filter(item => item.id !== row.id)
						this.paramsSearchEmp.filterList = newList
						this.mvtMovementList.push(row)
						this.rowsAdded[row.id] = row
					}
					if(this.typeAdd === 'vcc'){
						let mvt = {
							id: 'invKey_'+this.invKey,
							mvtAccountInv: row.mvtAccountInv,
							mvtAccountLib: row.mvtAccountLib,
							mvtSolde: row.mvtSolde,
							mvtSoldeLib: row.mvtSoldeLib,
							justificatif: row.justificatif
						}
						this.mvtMovementList.push(mvt)
						// row.id =  'invKey_'+this.invKey
						// this.mvtMovementList.push(row)
						this.invKey = this.invKey+1;
					}
				
				}
				if(this.activeAddRow)
					this.activeAddRow = false
				else
					this.activeAddRow = true
			},
			async amountToLetter(e, attrName) {
				if(e.target.value && e.target.value.length > 2 && attrName && attrName != ''){
					await this.$store.dispatch('axiosGet', { url: '/api/sequence/convert?amount='+e.target.value
					})
					.then(response => {
						if(response.data && response.data.results)
							this.amountLetter[attrName] = response.data.results
					}).catch(error => {
						console.log('error catch convert amount == ', error.message)
					})
				}
			},
			async handleSubmit() {
				this.instance.mvtAccount = this.mvtAccountSelected
				this.instance.mvtTypeMvt = this.mvtTypeMvtSelected
				this.instance.mvtTypeDep = this.mvtTypeDepSelected
				this.instance.mvtAccountInv = this.mvtAccountInvSelected
				let result = await this.v$.$validate()
				// NEW
				let msgError = ''

				// mvtAccList[0]?.prsPerson?.id > 1 - SI FSR on exige cpt invers
				if(this.mvtTypeDepSelected && [7].includes(this.mvtTypeDepSelected) ){
					let mvtAccList = this.mvtAccountList.filter(item => item?.id == this.instance.mvtAccount)
					if(mvtAccList[0]?.prsPerson?.id > 1 && !this.instance.mvtAccountInv)
						msgError = msgError + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner le compte inverse</li>"
				}
				else 	if(this.mvtTypeDepSelected && [6].includes(this.mvtTypeDepSelected) ){
					if(this.mvtMovementList.length == 0)
						msgError = msgError + "<li> <a href=\"#\" class=\"close\" data-dismiss=\"alert\" aria-label=\"close\">&times;</a>Veuiller renseigner au moins une ligne de virement</li>"
					else {
						for(let i = 0; i < this.mvtMovementList.length; i++) {
							let mvt = this.mvtMovementList[i]; 
							if(mvt.mvtAmount && mvt.mvtAmount != null)
								result = true
							else{
								if(msgError != '')
									msgError = msgError + '<br>'
								msgError = msgError + 'Montant non renseigné sur la ligne: '+ (i+1)+' pour le compte ' + mvt.mvtAccountLib
							}
							if(mvt.justificatif && mvt.justificatif != null)
								result = true
							else{
								if(msgError != '')
									msgError = msgError + '<br>'

								msgError = msgError +'Justificatif non renseigné sur la ligne: '+ (i+1)+' pour le compte ' + mvt.mvtAccountLib
							}
							
						}
					}
				}
				if(msgError != ''){
					this.$store.getters.getErrorMsgFormatted(msgError);
					result = false
					return
				}
				if (!result)
					return
				else{
					this.$store.dispatch('initFlash');
					this.$store.dispatch('loading')
					this.axiosPost()
				}
			},
			async axiosPost() {
				try {
					if(this.itemId && !isNaN(this.itemId)){
						await this.$store.dispatch('axiosPut', {
							domain: 'mvtmovement',
							data: this.instance,
							id:this.itemId
						})
						.then(res => {
							// console.log('res update === ', res)
							this.$nextTick(() => {
								let msg = this.$t("mvtmovement.label") + " "+this.itemId;
								
								if(res.data && res.data.error){
									msg = msg+ ' '+ res.data.error;
									this.$store.dispatch('showToast', {
										type: 'warning', message: msg
									});
									this.typeView = 'show'
									this.$router.push('/movement/show/'+this.itemId)
								}
								else{
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.updated.message', { obj: msg})
									});
									this.$router.go(0)
								}
								// this.typeView = 'show'
								// this.$router.push('/mvtmovement/show/'+this.itemId)
								this.$store.dispatch('unloading')
							});
						})
						.catch(error => {
							console.log('error update === ', error)
							this.$store.getters.getErrorMsgFormatted(error);
							this.$store.dispatch('unloading')
						})
					}
					else {
						if(this.typeAdd === 'one'){
							await this.$store.dispatch('axiosPost', {
								domain: 'mvtmovement',
								data: this.instance //data
							})
							.then(res => {
								this.$nextTick(() => {
									let msg = this.$t("mvtmovement.label") + " "+res.data.id;
									this.$store.dispatch('showToast', {
										type: 'success', message: this.$t('toast.created.message', { obj: msg})
									});
									this.typeView = 'show'
									this.$router.push('/movement/show/'+res.data.id)
									this.$store.dispatch('unloading')
								});

							})
							.catch(error => {
								this.$store.getters.getErrorMsgFormatted(error);
								this.$store.dispatch('unloading')
							})
						}
						if(this.typesMany.includes(this.typeAdd)){
							for(let i = 0; i < this.mvtMovementList.length; i++) {
								let mvt = this.mvtMovementList[i];
								let instanceMvt = {}
								if(this.typeAdd === 'remb')
									instanceMvt = {
										mvtAccount: mvt.id,
										mvtTypeMvt: mvt.mvtTypeMvt,
										mvtTypeDep: mvt.mvtTypeDep,
										mvtAmount: mvt.mvtAmount,
										justificatif: mvt.justificatif
									}
								if(this.typeAdd === 'vcc'){
									instanceMvt = {
										mvtAccount: this.instance.mvtAccount,
										mvtTypeMvt: this.instance.mvtTypeMvt,
										mvtTypeDep: this.instance.mvtTypeDep,
										mvtAccountInv: mvt.mvtAccountInv,
										mvtAmount: mvt.mvtAmount,
										mvtDate: mvt.mvtDate,
										justificatif: mvt.justificatif
									}
								}
								await this.$store.dispatch('axiosPost', {
									domain: 'mvtmovement',
									data: instanceMvt
								})
								.then(res => {
									this.$nextTick(() => {
										let msg = (i+1) + '. ' ;
										if(this.typeAdd === 'remb')
											msg = msg+ instanceMvt?.justificatif + " de "+mvt?.mvtAccountLib;
										if(this.typeAdd === 'vcc')
											msg = msg+ 'Virement de '+ mvt.mvtAmount?.toString() +' sur le compte de '+mvt?.mvtAccountLib;
										this.$store.dispatch('showToast', {
											type: 'success', message: this.$t('toast.created.message', { obj: msg})
										});
									});

								})
								.catch(error => {
									this.$store.getters.getErrorMsgFormatted(error);
									this.$store.dispatch('unloading')
								})
							}
							// this.typeView = 'show'
							this.$router.push('/mvtmovementlist/')
							this.$store.dispatch('unloading')

						}

					}
					
				}
				catch (e) {
					console.log('Error ', e)
				}

			},

			async produce() {
				this.$store.dispatch('loading', this.$t('toast.produce.message'))
				let modelName = 'REÇU DE '+this.instance.mvtTypeDep?.typeDepName.toUpperCase()
				
				let	detailsTop = '<FONT size=5><b>'+modelName+' </b> </FONT>';

				detailsTop = detailsTop +'<br><br><FONT size=1><i> Bamako le, </i> <b></FONT>' + this.$moment(this.instance.mvtDate).format(this.$store.getters.formatDateShort) + '</b>';
				
				let detailsTopC1 = '<i> '+ this.$t('mvtmovement.mvtAccount') +' : </i> <b> ' +this.instance.mvtAccount.lib.replace('|', '-') + '</b>';

				detailsTopC1 = detailsTopC1 + '<br><i> '+ this.$t('mvtaccount.accountNumber') +' : </i> <b> ' +this.instance.mvtAccount?.accountNumber + '</b>';
				
				let	detailsTopC2 = '<i> '+ this.$t('prsperson.address') +' : </i> <b> ' +this.instance.mvtAccount.prsPerson?.address + '</b>';
				detailsTopC2 = detailsTopC2 + '<br><i> '+ this.$t('prsperson.phoneAddress') +' : </i> <b> ' +this.instance.mvtAccount.prsPerson?.phoneAddress + '</b>';

				/*let	detailsTopC2 = '<i> Bamako le, </i> <b>' + this.$moment(this.instance.mvtDate).format(this.$store.getters.formatDateShort) + '</b>';*/

				let trFoot = ''
				/*trFoot = '<i> '+ this.$t('mvtmovement.mvtAmount') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.mvtAmount) + '</b>';
				
				if(trFoot != '')
					trFoot = trFoot + '<br>'
				trFoot = trFoot + '<i> '+ this.$t('mvtmovement.mvtSolde') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.mvtSolde) + '</b>';*/
				
				let libBot = '<i> DÉTAILS </i>'
				// let	detailsBot = '. <br>.'
				let detailsBot = '<i> '+ this.$t('mvtmovement.justificatif') +' : </i> <b>' +this.instance?.justificatif + '</b>';
				

				let detailsBotC1 = ''
				let detailsBotC2 = ''
				detailsBotC1 = '<i> '+ this.$t('mvtmovement.mvtAmount') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance?.mvtAmount) + '</b>';
				detailsBotC1 = detailsBotC1 + '<br><i><b> '+this.amountLetter.mvtAmount +'</b> </i>';
				
				if(detailsBotC2 != '')
					detailsBotC2 = detailsBotC2 + '<br>'
				detailsBotC2 = detailsBotC2 + '<i> '+ this.$t('mvtmovement.mvtSolde') +' : </i> <b>' +this.$store.getters.formatAmount(this.instance.mvtSolde) + '</b>';
				detailsBotC2 = detailsBotC2 + '<br><i><b> '+this.amountLetter.mvtSolde +'</b> </i>';

				let strParams = "jasper=LIC&strFormat=PDF"

				if(detailsTop != '')
					strParams = strParams +"&detailsTop="+detailsTop
				if(detailsTopC1 != '')
					strParams = strParams +"&detailsTopC1="+detailsTopC1
				if(detailsTopC2 != '')
					strParams = strParams +"&detailsTopC2="+detailsTopC2
				if(trFoot != '')
					strParams = strParams +"&trFoot="+trFoot

				if(libBot != '')
					strParams = strParams +"&libBot="+libBot

				if(detailsBot != '')
					strParams = strParams +"&detailsBot="+detailsBot
				if(detailsBotC1 != '')
					strParams = strParams +"&detailsBotC1="+detailsBotC1
				if(detailsBotC2 != '')
					strParams = strParams +"&detailsBotC2="+detailsBotC2
				
				strParams = strParams + "&titreDoc=null"//+ this.$t(this.instanceClassAttr.instanceClass +'.label')

				let fileName = modelName + '_'+this.instance.id
				strParams = strParams + "&fileName="+ fileName
				if(this.instance.mvtAccount.prsStore)
					strParams = strParams + "&storeName=" + '<FONT size=1><i>*** '+this.instance.mvtAccount.prsStore?.storeName +' ***</i></FONT> '

				await this.$store.dispatch('axiosGet', {
					url: '/api/mvtmovement/produce?' + strParams, strResponseType: 'blob'
				})
				.then(response => {
					var fileURL = window.URL.createObjectURL(new Blob([response.data]));
					this.pdfName = fileName+'.pdf'
					this.pdfSrc = fileURL
					this.$nextTick(()=> {
						this.$refs.componentModalPdf.modalToggle();
					});
					
				})
				.catch(error => {
					console.log('error catch == ', error.message)
				})
				this.$store.dispatch('unloading')
			},

			
		}
		
	}

</script>